import { useMemo, useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { faqItems } from "@/mocks/siteData";

export default function FaqSection() {
  const [query, setQuery] = useState("");
  const [openSet, setOpenSet] = useState<number[]>([0]);

  const filtered = useMemo(() => {
    const keyword = query.trim();
    if (!keyword) return faqItems;
    return faqItems.filter(
      (item) => item.q.includes(keyword) || item.a.includes(keyword),
    );
  }, [query]);

  const toggle = (index: number) => {
    setOpenSet((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="FAQ"
          title="访问问题速查"
          desc="下面这些问题覆盖了绝大多数“打不开、进不去、找不准”的情况。可在搜索框输入关键词，快速定位相关问题。"
        />

        <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <div className="relative w-full sm:max-w-sm">
            <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索关键词，如：打不开、地址、仿冒"
              className="w-full pl-10 pr-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/30"
            />
          </div>
          <span className="text-xs md:text-sm text-foreground-500">
            共 {filtered.length} 条相关结果
          </span>
        </div>

        <div className="mt-5 space-y-3">
          {filtered.length === 0 && (
            <div className="p-8 text-center rounded-xl bg-background-50 border border-background-200">
              <i className="ri-emotion-sad-line text-3xl text-foreground-300" />
              <p className="mt-3 text-sm text-foreground-500">
                没有找到相关问题，换个关键词试试看。
              </p>
            </div>
          )}

          {filtered.map((item) => {
            const index = faqItems.indexOf(item);
            const isOpen = openSet.includes(index);
            return (
              <div
                key={item.q}
                className="rounded-xl bg-background-50 border border-background-200 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left cursor-pointer hover:bg-background-100/60 transition-colors"
                >
                  <span className="flex items-start gap-3">
                    <i className="ri-question-line text-primary-600 mt-0.5" />
                    <span className="text-sm md:text-base font-heading font-medium text-foreground-950">
                      {item.q}
                    </span>
                  </span>
                  <i
                    className={`shrink-0 text-foreground-500 transition-transform duration-200 ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  />
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5 -mt-1">
                    <p className="pl-7 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}